import {FormatterProps} from './Common';
import React from 'react';


export const Basic: React.FC<FormatterProps> = (props) => {
    const formatter = layoutFormatters[props.field.type];

    return formatter ? formatter(props) : unknownFieldType(props);
};

const SingleSelect: React.FC<FormatterProps> = (props) => (
    <div
        key={props.field.name}
        className="col-md-3 col-sm-6 form-group">
        <label htmlFor={props.field.name}>{props.field.label}: </label>
        <select
            id={props.field.name}
            className="custom-select"
            onChange={($this) =>
                props.onChange(props.id, $this.currentTarget.value)
            }>
            <option key="0" />
            {props.field.options.map((o) => (
                <option key={o} value={o}>
                    {o}
                </option>
            ))}
        </select>
    </div>
);

const MultiSelect: React.FC<FormatterProps> = (props) => (
    <div
        key={props.field.name}
        className="col-md-3 col-sm-6 form-group">
        <label htmlFor={props.field.name}>{props.field.label}: </label>
        <select
            id={props.field.name}
            className="custom-select"
            onChange={($this) =>
               props.onChange(props.id, $this.currentTarget.value)
            }>
            <option key="0" />
            {props.field.options.map((o) => (
                <option key={o} value={o}>
                    {o}
                </option>
            ))}
        </select>
    </div>
);

const LongText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Basic Reformat me: {props.field.type}:</strong>
    </div>
);

const ShortText: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Basic Reformat me: {props.field.type}:</strong>
    </div>
);

const UnknownFieldType: React.FC<FormatterProps> = (props) => (
    <div>
        <strong>Strange new unsupported type detected {props.field.type}</strong>
    </div>
);

const singleSelect = (props: FormatterProps) => <SingleSelect {...props} />;
const multiSelect = (props: FormatterProps) => <MultiSelect {...props} />;
const shortText = (props: FormatterProps) => <ShortText {...props} />;
const longText = (props: FormatterProps) => <LongText {...props} />;
const unknownFieldType = (props: FormatterProps) => <UnknownFieldType {...props} />;

// Mapping of layout name to formatter
const layoutFormatters: { [key: string]: (props: FormatterProps) => JSX.Element } = {
    'Single Select': singleSelect,
    'Multi Select': multiSelect,
    'Short Text': shortText,
    'Long Text': longText
};


// WEBPACK FOOTER //
// ./src/public/search/layout/Basic.tsx